import { environment } from '../environments/environment';

export const config = {
  apiUrl: environment.apiUrl
};